import { LocationTableItem } from 'components/waste-management/interfaces'

export const toTableRowItems = (items: LocationTableItem[]) =>
  items.map(item => ({
    id: item.id,
    name: item.name ?? '',
    metiCode: item.metiCode ?? '',
    legalEntity: item.legalEntity ?? '',
    type: item.type ?? '',
    subtype: item.subtype ?? '',
    categories: item.categories ?? []
  }))
